<template>
  <div role="progressbar" class="oct-dot-progress">
  </div>
</template>

<script>
export default {
  components: {},
  name: 'OctDotProgress',
  props: {
    /** Whether or not the element is fullscreen */
    fullscreen: {
      type: Boolean,
      default: true
    }
  }
}
</script>

<style scoped lang="scss">
@import "../theme/variables";
@import "../grid/variables";
@import "../typography/variables";
@import "../typography/mixins";

.oct-dot-progress {
  position: relative;
  min-height: calc(100vh - oct-rem(64));

  .oct-account-header & {
    min-height: calc(100vh - oct-rem(64+72));
  }

  &:after {
    content: "";
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    margin: auto;
    width: oct-rem(8);
    height: oct-rem(8);
    background-color: #000;
    border-radius: 50%;
    animation: blink .1s ease-out 0s infinite alternate;
  }

@media screen and (min-width: map-get($grid-breakpoints, 'md')) {
  min-height: calc(100vh - oct-rem(96));

  .oct-account-header & {
    min-height: calc(100vh - oct-rem(96+80));
  }
}
}

@keyframes blink {
  0% {opacity: 1}
  100% {opacity: 0}
}
</style>
